// extracted by mini-css-extract-plugin
export default {"hideTooltip":"D8-z","fadeIn":"E8-z","delay":"F8-z","recommendedSizeTooltip":"G8-z"};